import React from 'react';

import { Formik } from 'formik';

import { VenueSelector } from '../radio/register/Selectors';

import TableFilterModal from 'CommonComponents/TableFilterModal';

import useSourceOptions from 'Hooks/useSourceOptions';

export default function CentralAssumptionsFilters(props) {
    const sourceOptions = useSourceOptions(props.venuesOptions);

    return (
        <TableFilterModal modalBodyClassNames="tw-w-128" noActions>
            <Formik
                enableReinitialize
                initialValues={{
                    source_ids: [],
                }}
                onSubmit={(values, actions) => {
                    props
                        .onSubmit(values)
                        .catch((e) => {
                            console.error(e);
                        })
                        .finally(() => {
                            actions.setSubmitting(false);
                        });
                }}
                onReset={() => props.onReset()}
            >
                {({ values, errors, touched, setFieldValue, isSubmitting, handleSubmit, handleReset }) => (
                    <div>
                        <div className="tw-flex tw-flex-col tw-gap-2">
                            <VenueSelector
                                label={$t('Source')}
                                venuesOptions={sourceOptions}
                                values={values}
                                valueKey="source_ids"
                                onChange={(venues) => {
                                    setFieldValue('source_ids', venues?.map((venue) => venue.value) || []);
                                }}
                                disabled={isSubmitting}
                                errors={errors.source_ids}
                                touched={touched.source_ids}
                            />
                        </div>
                        <div className="tw-flex tw-justify-end tw-gap-x-2 tw-pt-3">
                            <button className="table__filter-modal__apply-btn !tw-bg-red" type="button" onClick={handleReset}>
                                {$t('Reset all')}
                            </button>
                            <button className="table__filter-modal__apply-btn" type="button" onClick={handleSubmit}>
                                {$t('Apply filters')}
                            </button>
                        </div>
                    </div>
                )}
            </Formik>
        </TableFilterModal>
    );
}
